export default "__VITE_ASSET__Ct4dlNk8__"